module.exports = __webpack_public_path__ + "img/estoque.d08c7ab4.svg";